/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import Loading from 'app/components/common/Loading.jsx';
import { Breakpoint } from 'react-socks';

class ProcessingModal extends React.Component {
    constructor(props) {
        super(props)

        this.closeClick = this.closeClick.bind(this);
        this.draggableRef = React.createRef();

    }

    closeClick() {

        this.props.closeAction();

    }

    render() {
        return (
            <div className="dlvr-modal" role="dialog" aria-hidden="false" aria-modal="true">
                <Breakpoint desktop only>
    				<Draggable nodeRef={this.draggableRef} handle=".dlvr-delete-modal" cancel=".dlvr-delete-modal">
    					<div ref={this.draggableRef} className="dlvr-delete-modal">
                            <div className="dlvr-delete-close" onClick={this.closeClick} role="button" aria-label="close">
                                <i className="fa fa-times"></i>
                            </div>
                            <div className="dlvr-delete-copy">
                                {this.props.modalCopy}
                            </div>
                            <Loading label={this.props.modalLabel} />
    					</div>
    				</Draggable>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className="dlvr-delete-modal">
                        <div className="dlvr-delete-close" onClick={this.closeClick} role="button" aria-label="close">
                            <i className="fa fa-times"></i>
                        </div>
                        <div className="dlvr-delete-copy">
                            {this.props.modalCopy}
                        </div>
                        <Loading label={this.props.modalLabel} />
                    </div>
                </Breakpoint>
			</div>
        );
    }

};

ProcessingModal.propTypes = {
    modalCopy: PropTypes.string,
    closeAction: PropTypes.func,
    modalLabel: PropTypes.string,
    context: PropTypes.string,
    modalName: PropTypes.string
};

ProcessingModal.defaultProps = {
    modalCopy: '',
    modalLabel: 'Loading',
    closeAction: null,
    context: 'default',
    modalName: 'ProcessingModal'
};

export default ProcessingModal;
